module.exports = __webpack_public_path__ + "img/bannerabout.55b22432.jpg";